import { MomentInput } from 'moment';
import moment from 'moment-timezone';
import React from 'react';

interface Props {
	date: MomentInput;
	format: string;
	timezone?: string;
}
const FormatDateTimezone: React.FC<Props> = ({ date, format, timezone }: Props) => {
	if (timezone) {
		return <>{moment(date).tz(timezone).format(format)}</>;
	}
	return <>{moment(date).format(format)}</>;
};
export default FormatDateTimezone;
